import { render } from "./UploadImageOnChat.vue?vue&type=template&id=5fdf764b&scoped=true"
import script from "./UploadImageOnChat.vue?vue&type=script&lang=js"
export * from "./UploadImageOnChat.vue?vue&type=script&lang=js"

import "./UploadImageOnChat.vue?vue&type=style&index=0&id=5fdf764b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fdf764b"

export default script